// extracted by mini-css-extract-plugin
export default {"container":"DeletedView-module__container--l1eEc","emptyWrapper":"DeletedView-module__emptyWrapper--T9hIx","animatedBackground":"DeletedView-module__animatedBackground--4oYdK"};